import ListItem from 'Components/Atoms/Fields/ListItem/ListItem';
import { Icon, ICONS } from 'Components/Atoms/Icon/Icon';
import React from 'react';

const SelectFieldItem = ({
    item, labels, iteration, 
    activeValues, onClick,
    ...props
}: any) => {

    const handleClick = () => {
        if (!!item.children) return;
        onClick(item.value)
    };
    const handleChildClick = (v) => onClick(v);

    return <ListItem
        hasChildren={!!item?.children}
        iteration={iteration+1}
        isActive={activeValues == item.value}
        label={
            <>
                <div style={{width: !item.children ? '100%' : 'auto'}} onClick={handleClick}>
                    { item.label }
                </div>

                {
                    item.children &&
                    <div>
                        <Icon
                            type={ICONS.CHEVRON_DOWN}
                            size={'small'}
                        />
                    </div>
                }
            </>
        }
    >
        {
            item?.children?.map(child =>
                <SelectFieldItem
                    key={child.value}
                    item={child}
                    labels={labels}
                    iteration={iteration+1}
                    activeValues={activeValues}
                    onClick={handleChildClick}
                />
            )
        }
    </ListItem>;
}

export default SelectFieldItem;